import { render, staticRenderFns } from "./SenetAlacakFormWizard.vue?vue&type=template&id=fdb7671c"
import script from "./SenetAlacakFormWizard.vue?vue&type=script&lang=ts"
export * from "./SenetAlacakFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports